import { faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button, Card, Col } from 'react-bootstrap';

const Instructor = (props) => {
    // distructuring data from props
    const { name, img, description, rating } = props.instructor;
    return (
        <Col>
            {/*Adding cards*/}
            <Card className="rounded rounded-3 border shadow">
                <div>
                    <Card.Img variant="top" src={img} className="w-25 mx-auto rounded-circle mt-4" />
                </div>
                <Card.Body>
                    <Card.Title className="fs-3">{name}</Card.Title>
                    <div className="my-3">
                        <FontAwesomeIcon className="text-success" icon={faStar} /> <span className="fw-bold">{rating}/5</span>
                    </div>
                    <Card.Text>
                        {description}
                    </Card.Text>
                </Card.Body>
                <Button className="py-2 fw-bold rounded-pill w-50 mx-auto mb-4" variant="success">Book trial lesson</Button>
            </Card>
        </Col>
    );
};

export default Instructor;